import {
    ActionHandler,
    useIntegratedActionBroadcaster,
} from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

export const BoloPanelActionHandler = observer(
    ({
        boloId,
        formHasHadDataSetAtLeastOnce,
    }: {
        boloId?: number;
        formHasHadDataSetAtLeastOnce: boolean;
    }) => {
        const workspacePanel = useWorkspacePanel<'EVENT'>();
        const isExistingBolo = !!boloId;

        const handleActions: ActionHandler<'EVENT_V2'> = useCallback(
            (action) => {
                if (isExistingBolo && formHasHadDataSetAtLeastOnce) {
                    switch (action.type) {
                        case 'FOCUS_ACTIVE_EVENT_WINDOW_PANEL': {
                            if (workspacePanel.isFocused) {
                                workspacePanel.zindex = -1;
                                workspacePanel.focus();
                                return true;
                            }
                            return false;
                        }
                    }
                }
            },
            [isExistingBolo, formHasHadDataSetAtLeastOnce, workspacePanel]
        );

        useIntegratedActionBroadcaster({
            id: 'BOLO_PANEL_FORM',
            windowType: 'EVENT_V2',
            handler: handleActions,
        });

        return null;
    }
);
